module.exports = __webpack_public_path__ + "static/administration-ff8f2341f9052a6811c9c58400e4d9ba.svg";